import React from 'react';
import { getValid$Cost } from '../../common/common';
import { useCartData} from '../../hooks/order';
import { useTranslation } from 'react-i18next';

const MobileInfomration = () => {
  const { t } = useTranslation();
  const { simCharge } = useCartData();
  const simFee = getValid$Cost(simCharge?.toFixed(2));
  return (
    <>
      <div className="cart-info-panel common-pannel mobile-info">
        <div className="b-bg-color">
          <h3>{t('mobile.mobileInfo')}</h3>
        </div>
        <ul>
          <li>{t('mobile.simFeeCollected')} <b>({simFee}).</b> {t('mobile.simFeeShipping')} <b>{t('mobile.simFeeShippingDays')}</b></li>
          <li>{t('mobile.orderShipBefore')} <b>{t('mobile.orderShipTime')}</b> {t('mobile.orderShipAfter')}</li>
          <li>{t('mobile.priceNotePre')} <b>{t('mobile.priceNoteNot')}</b> {t('mobile.priceNotePost')}</li>
        </ul>
      </div>
    </>
  )
}
export default MobileInfomration;
